export default __webpack_public_path__ + "static/media/logo-light.540358dc.png";